<div class="container">
  <mat-card class="article-title-card">
   {{'articleSearch.transactions' | translate}} : ({{ saleService.totalSales }})
  </mat-card>
  <article-search-list></article-search-list>
</div>
